import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import { configureStore } from '../../../store'
import App from './App'
// import { Container } from 'semantic-ui-react'
// import Header from 'Features/ui/components/Header'
// import AuthFooter from 'Features/ui/components/AuthFooter'
import ErrorMessageDialog from './ErrorMessageDialog'
import LoadingDialog from './LoadingDialog'

const store = configureStore()

export default () => (
    <Provider store={store}>
        <Router>
            <div>
                {/* <div> */}
                {/* <Header moduleName="" keyword="withName" />
                <Container> */}
                <App />
                {/* </Container> */}
                {/* <AuthFooter/> */}
                {/* </div> */}
                <ErrorMessageDialog />
                <LoadingDialog />
            </div>
        </Router>
    </Provider>
)


// WEBPACK FOOTER //
// ./src/front/features/ui/components/Root.prod.js